<template>
  <!-- 查询结果页 -->
  <div>
    <van-nav-bar
      title="缴费信息"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <div class="mainbox">
      <Head v-if="logo" :logo="logo"></Head>
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        head-height="120"
      >
        <div class="cont">
          <div class="touch"></div>
          <List
            v-if="payied.length > 0"
            :dataList="payied"
            @func="handleItem(arguments)"
            :isTicket="true"
            @printNotice="printNotice"
            @touchmove.stop
          ></List>
          <div v-if="dataList.length > 0" @touchmove.stop>
            <List :dataList="dataList" @func="handleItem(arguments)"></List>
            <div class="replay" @click="handlePage">
              <div v-if="hasmore">
                <div v-if="pageLoading">
                  <van-loading size="24px">加载中...</van-loading>
                </div>
                <div v-else><van-icon name="replay" />点击加载更多数据</div>
              </div>
              <div v-else>暂无更多数据</div>
            </div>
          </div>
          <div v-else class="nodata">
            <van-loading
              size="24px"
              v-if="dataList.length == 0 && loading && refreshing == false"
              >加载中...</van-loading
            >
            <div v-if="dataList.length == 0 && !loading && payied.length == 0">
              暂无数据
            </div>
          </div>
        </div>
        <!-- 支付按钮 -->
        <van-button
          round
          block
          type="info"
          :disabled="usepay"
          v-if="dataList.length > 0"
          @click="getcode"
          class="btn"
          >生成二维码</van-button
        >

        <van-button
          round
          block
          type="info"
          v-if="dataList.length > 0 && isCash"
          :disabled="usepay"
          @click="cashPay"
          class="btn"
          >现金缴费</van-button
        >

        <Foot
          v-if="list && list.bottomMessage && list.bottomMessage.length > 0"
          :list="list"
        ></Foot>
      </van-pull-refresh>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="showModel" title="收费项目明细">
      <div class="content">
        <div v-for="(item, index) in detailList" :key="index">
          {{ item.itemName }}:{{ Number(item.actualAmt).toFixed(2)  }}{{ item.unit }}
        </div>
      </div>
    </van-dialog>
    <div class="codedialog">
      <van-dialog
        v-model="QrcodeDialogVisible"
        title="二维码生成成功，请尽快付款"
      >
        <div class="payunit">
          <p>缴款人：{{ paymentUnit }}</p>
        </div>
        <div
          id="qrCode"
          ref="qrCodeDiv"
          style="margin: 0 auto; width: 200px"
        ></div>
        <div class="codefoot">
          <p>缴款金额：{{ Number(paymentTotal).toFixed(2) }}元</p>
          <p>支持支付宝、微信扫码</p>
        </div>
      </van-dialog>
    </div>

    <div id="widget" />

    <div
      ref="print_qrcode_dlg"
      class="page-break"
      style="display: none; padding: 20px"
    >
      <div style="font-size: 42px">
        <h2 style="text-align: center" ref="showTitle"></h2>
        <br />
        <div ref="showMessage" style="margin: 20px 20px"></div>
        <br />
        <div style="text-align: center; margin-top: 10px">
          <img id="qrcodeimg" />
        </div>
        <div
          style="display: flex; justify-content: flex-end; margin-right: 20px"
          ref="showInscribe"
        ></div>
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import Foot from "@/components/foot";
import Head from "@/components/head";
import List from "@/components/list";
import QRCode from "qrcodejs2";
import { Dialog, Notify, Toast } from "vant";
import { judgeVde } from "@/utils/publicJudge";
// 重写 tofixed方法
Number.prototype.toFixed = function (d) {
     var s = this + "";
     if (!d) d = 0;
     if (s.indexOf(".") == -1) s += ".";
     s += new Array(d + 1).join("0");
     if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
         var s = "0" + RegExp.$2, pm = RegExp.$1, a = RegExp.$3.length, b = true;
         if (a == d + 2) {
             a = s.match(/\d/g);
             if (parseInt(a[a.length - 1]) > 4) {
                 for (var i = a.length - 2; i >= 0; i--) {
                     a[i] = parseInt(a[i]) + 1;
                     if (a[i] == 10) {
                         a[i] = 0;
                         b = i != 1;
                     } else break;
                 }
             }
             s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");

         } if (b) s = s.substr(1);
         return (pm + s).replace(/\.$/, "");
     }
     return this + "";
 };
let loadedMineMapJs = false;
export default {
  components: {
    Foot,
    Head,
    List,
  },
  data() {
    return {
      active: 0,
      idCard: "",
      paymentUnit: "",
      phone: "",
      vde: "",
      dataList: [],
      loading: true,
      usepay: false,
      list: [], //温馨提示列表
      logo: "",
      page: 1,
      limit: 5,
      total: 0,
      hasmore: true,
      pageLoading: false,
      showModel: false,
      detailList: [],
      refreshing: false,
      QrcodeDialogVisible: false,
      showHistory: false,
      bizId: "",
      payied: [],
      isCash: false,
      paymentTotal: "",
    };
  },
  created() {
    if (this.$route.query.vde === undefined) {
      this.vde = "";
    } else {
      this.vde = this.$route.query.vde;
    }
    //判断vde
    judgeVde({ vde: this.vde }, this);
    this.idCard = this.$route.query.idCard;
    this.paymentUnit = this.$route.query.paymentUnit;
    this.phone = this.$route.query.phone;
    this.logo = sessionStorage.getItem("logoImg");
    this.list = JSON.parse(sessionStorage.getItem("footList"));

    this.getData(); //查询进入
  },
  destroyed() {
    Toast.clear();
  },
  methods: {
    // 子传父的参数（用于弹窗）
    handleItem(data) {
      this.showModel = data[0];
      this.detailList = data[1];
    },
    // 下拉刷新
    async onRefresh() {
      this.page = 1;
      this.limit = 5;
      this.dataList = [];
      this.loading = true;
      if (this.showHistory) {
        await this.getPaied();
      }
      await this.getData();
      await Toast("刷新成功");
      this.hasmore = true;
      this.refreshing = false;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    change() {},
    // 分页
    handlePage() {
      this.pageLoading = true;
      if (this.dataList.length < this.total) {
        this.page++;
        this.getData();
      } else {
        setTimeout(() => {
          this.pageLoading = false;
          this.hasmore = false;
        }, 500);
      }
    },
    // 从查询页进来的
    getData() {
      if (this.page == 1) {
        this.dataList = [];
        this.loading = true;
      } else {
        this.pageLoading = true;
      }
      let data = {
        idCard: this.idCard,
        paymentUnit: this.paymentUnit,
        phone: this.phone,
        confirmType: 0,
        type: 2,
        bizId: "",
        vde: this.vde,
        mon: "",
        page: this.page,
        limit: this.limit,
      };
      return new Promise((resolve) => {
        this.request({
          url:'/mobile/listPayData',
          method:'get',
          params:data
        }).then((res)=>{
          this.loading = false;
          this.pageLoading = false;
          if (res.data.code == 1000) {
            if (res.data.result.list.length != 0) {
              this.isCash = res.data.result.extraParams.isCash;
              this.dataList = this.dataList.concat(res.data.result.list);
              this.total = res.data.result.total;
            } else {
              if (!this.showHistory) {
                if (this.dataList.length == 0) {
                  Dialog.confirm({
                    title: "提示",
                    message: "暂未查询到数据，是否到新增页面新增数据",
                  })
                    .then(() => {
                      this.$router.push({ path: "/loginIndex/add?vde="+this.vde });
                    })
                    .catch(() => {});
                }
              }
            }
            this.$forceUpdate();
          }
          resolve();

        })
      });
    },
    // 拿已缴费的数据
    getPaied() {
      this.payied = [];
      let data = {
        idCard: this.idCard,
        paymentUnit: this.paymentUnit,
        phone: this.phone,
        confirmType: 1,
        type: 2,
        bizId: this.bizId,
        vde: this.vde,
        mon: "",
        page: this.page,
        limit: this.limit,
      };
      return new Promise((resolve) => {
        this.request({
          url:'/mobile/listPayData',
          method:'get',
          params:data
        }).then((res)=>{
          this.loading = false;
          this.pageLoading = false;
          if (res.data.code == 1000) {
            if (res.data.result != null) {
              this.payied = res.data.result.list;
            } else {
            }
            this.$forceUpdate();
          }
          resolve();

        })
      });
    },
    // 生成二维码
    getcode() {
      let noticeNo = "";
      let sysType = "";
      let payAmt = "";
      let bool = this.dataList.some((val) => {
        return val.checked;
      });
      if (bool) {
       
        let isConfirm
        this.usepay = true;
        this.dataList.forEach((val) => {
          if (val.checked == true) {
            noticeNo = val.noticeNo;
            payAmt = val.paymentTotal;
            this.paymentUnit = val.paymentUnit;
            this.paymentTotal = val.paymentTotal;
            this.bizId = val.uId;
            isConfirm = val.isConfirm;
            if (val.sysType == 1) {
              sysType = 1;
            } else {
              sysType = 2;
            }
          }
        });
         let data = {
          noticeNo: noticeNo,
          sysType: sysType,
          payAmt: payAmt,
        };
        if (isConfirm == '9') {
          Dialog.confirm({
            title: '提示',
            message: '该数据的状态为支付中，是否继续生成二维码？',
          })
            .then(() => {
              this.getQrcode(data)
            })
            .catch(() => {
                this.usepay = false;
            });
        }else {
          this.getQrcode(data)
        }
      
      } else {
        Dialog.alert({
          title: "提示",
          message: "请选择需要缴费的项目",
        }).then(() => {});
      }
    },
    getQrcode(data) {
       Toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
        });
        this.request({
          url:'/pay/getQrcodeUrl',
          method:'post',
          data:data
        }).then((res)=>{
          Toast.clear();
          if (res.data.code === 1000) {
            // 获取返回的二维码连接地址
            this.QrcodeDialogVisible = true;
            setTimeout(() => {
              document.getElementById("qrCode").innerHTML = "";
              new QRCode(this.$refs.qrCodeDiv, {
                text: res.data.result.qrCodeUrl,
                width: 200,
                height: 200,
                colorDark: "#333333", // 二维码颜色
                colorLight: "#ffffff", // 二维码背景色
                correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
              });
            }, 100);
            this.showHistory = true;
            setTimeout(() => {
              $(".codedialog .van-dialog__header").css({
                background: "#1989fa",
                color: "#fff",
              });
            });
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            }).then(() => {});
          }
          this.usepay = false;
        })
    },
    // 现金缴费
    cashPay() {
      let noticeNo = "";
      let sysType = "";
      let payAmt = "";
      let isConfirm = "";
      let bizId = "";
      let bool = this.dataList.some((val) => {
        return val.checked;
      });
      if (bool) {
        
        this.usepay = true;
        this.dataList.forEach((val) => {
          if (val.checked == true) {
            noticeNo = val.noticeNo;
            payAmt = val.paymentTotal;
            isConfirm = val.isConfirm;
            bizId = val.uId;
            this.bizId = val.uId;
            if (val.sysType == 1) {
              sysType = 1;
            } else {
              sysType = 2;
            }
          }
        });
        if (isConfirm != 0) {
          Dialog.alert({
            title: "提示",
            message: "该数据不处于未缴费状态，请刷新后重试",
          }).then(() => {
             this.usepay = false;
          });
        } else {
          let data = {
            deviceType: "phone",
            noticeNo: noticeNo,
            sysType: sysType,
            payAmt: payAmt,
          };
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration: 0,
          });
          this.request({
            url:'/pay/cashPay',
            method:'post',
            data:data
          }).then((res)=>{
            Toast.clear();

            if (res.data.code == 1000) {
              const bill = {
                bizId: bizId,
                noticeNo: noticeNo,
                sysType: data.sysType,
              };
              this.request({
                baseURL: process.env.VUE_APP_PAY_URL,
                url:'/pay/showETicket',
                method:'get',
                params:bill
              }).then((res1)=>{
                if (res1.data.code == 1000) {
                  Notify({
                    type: "success",
                    message: "现金缴费成功并成功开具电子票",
                  });
                } else {
                  Dialog.alert({
                    title: "提示",
                    message:
                      "现金缴费成功，开具电子票失败，错误信息：" +
                      res1.data.message,
                  }).then(() => {});
                }
                this.showHistory = true;

              })
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.message,
              }).then(() => {});
            }
            this.usepay = false;

          })
        }
      } else {
        Dialog.alert({
          title: "提示",
          message: "请选择缴费的缴费数据",
        }).then(() => {});
      }
    },
    ///////////////////////////////////////////////////////////////////////////云打印begin
    printNotice(index) {
      let data = {};
      data.noticeNo = this.payied[index].noticeNo;
      data.sysType = this.payied[index].sysType == 1 ? "1" : "2";
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/cloudPrint/getPrintMessage',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code == 1000) {
          Dialog.confirm({
            title: "提示",
            message: "确定要打印吗?",
          })
            .then(() => {
              this.printPayNoticeBack(res.data.message, "缴费成功告知单");
            })
            .catch(() => {});
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.message,
          }).then(() => {});
        }

      })
    },
    printPayNoticeBack(printMessage, title) {
      Toast.loading({
        message: "正在打印...",
        forbidClick: true,
        duration: 0,
      });
      this.$refs.showTitle.innerHTML = "";
      this.$refs.showTitle.append(title);
      let date = new Date();
      let time =
        date.getFullYear() +
        "年" +
        (date.getMonth() + 1) +
        "月" +
        date.getDate() +
        "日" +
        date.getHours() +
        ":" +
        date.getMinutes();
      this.$refs.showInscribe.innerHTML = "";
      this.$refs.showInscribe.append(
        "<br>打印时间:<br>" + time + "<br><br><br><br><hr>"
      );
      this.$refs.showMessage.innerHTML = "";
      this.$refs.showMessage.append(printMessage);

      var image = new Image();
      image.src = require("@/assets/img/xiaochengxu.jpg");

      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        $("#qrcodeimg").attr("src", canvas.toDataURL("image/jpg"));

        let printHtml = this.initPayNoticeHtml();
        printHtml += this.$refs.print_qrcode_dlg.innerHTML;
        printHtml = this.backPrintHtml(printHtml);
        this.printFinalRequest(printHtml);
      };
    },
    initPayNoticeHtml() {
      let printHtml =
        '<html lang="en"><head><meta charset="UTF-8"><title>打印预览</title><style>\
							@media print{\
								.page-break {page-break-after:always;}\
							}\
					</style></head><body>';
      return printHtml;
    },
    /**
     * 替换打印html中的特殊字符
     * @param {*} printHtml
     */
    backPrintHtml(printHtml) {
      printHtml += "</body></html>";
      printHtml = printHtml.replace(/undefined/g, "&nbsp;");
      printHtml = printHtml.replace(/&gt;/g, ">");
      printHtml = printHtml.replace(/&lt;/g, "<");
      printHtml = printHtml.replace(/&amp;/g, "&");
      printHtml = printHtml.replace(/data-v-d7e08c76=\"\"/g, "");
      return printHtml;
    },
    printFinalRequest(printContent) {
      let data = {
        printContent: printContent,
      };
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/cloudPrint/dascomPrint?printContent',
        method:'post',
        data:data
      }).then((res)=>{
        Toast.clear();
        Dialog.alert({
          title: "提示",
          message: res.data.message,
        }).then(() => {});

      })
    },
    ///////////////////////////////////////////////////////////////////////////云打印end
  },
};
</script>

<style lang="scss" scoped>
.mainbox {
  padding: 60px 2vw 0 2vw;
  box-sizing: border-box;
}
.van-nav-bar {
  z-index: 999;
}
.nodata {
  text-align: center;
  font-size: 14px;
  margin: 30px 0;
  color: #888;
}
.cont {
  margin-top: 10px;
  position: relative;
  .replay {
    text-align: center;
    color: #999;
  }
  .touch {
    height: 30vh;
    width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }
}
.content {
  text-align: center;
  padding: 15px 0;
  line-height: 24px;
}
.btn {
  margin-top: 20px;
}
.payunit {
  background: #1989fa;
  color: #fff;
  text-align: center;
  margin-bottom: 10px;
  padding: 10px;
  position: relative;
  top: -1px;
  font-weight: bold;
}
.codefoot {
  text-align: center;
  > p:nth-of-type(1) {
    font-weight: bold;
    color: #ee0a24;
    margin-top: 20px;
  }
  > p:nth-of-type(2) {
    color: #888;
    margin-top: 10px;
    font-size: 12px;
  }
}
</style>
